const state = {
  users: null,
  user: null,
  usersPath: ''
}

const getters = {
  usersPath: state => state.usersPath,
  users: state => state.users,
  user: state => state.user
}

const actions = {
  setUsersPath ({ rootState, commit, state }) {
    const { self } = rootState
    const { domainsPath } = self
    const { user } = state
    commit('SET_USERS_PATH', `${domainsPath}/users/${user.id.numberStr}`)
  }
}

const mutations = {
  SET_USERS_PATH (state, usersPath) {
    state.usersPath = usersPath
  },
  SET_USERS (state, users) {
    const { list } = users
    const user = list[0]
    state.users = users
    state.user = user
  },
  SET_USER (state, user) {
    state.user = user
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
